import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api';

const EditCashReceiveds = () => {
    const { id } = useParams(); // Get cash received ID from URL
    const navigate = useNavigate();

    const [staffId, setStaffId] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [amount, setAmount] = useState('');
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        // Fetch cash received details
        fetch(`${BASE_URL}cashreceived/${id}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                if (data.status === 1) {
                    setStaffId(data.data.staff_id || '');
                    setCustomerId(data.data.c_id || '');
                    setAmount(data.data.amount || '');
                    setDescription(data.data.description || '');
                    setLoading(false);
                } else {
                    setError('Failed to fetch data. Please try again later.');
                    setLoading(false);
                }
            })
            .catch((err) => {
                console.error('Error fetching cash received details:', err);
                setError('Failed to fetch data. Please check your network connection.');
                setLoading(false);
            });
    }, [id]);

    const handleSubmit = (event) => {
        event.preventDefault();

        const formData = {
            staff_id: staffId,
            c_id: customerId,
            amount,
            description,
        };

        fetch(`${BASE_URL}cashreceived/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 1) {
                    alert('Cash received entry updated successfully');
                    navigate('/CashReceivedList');
                } else {
                    alert('Error updating cash received entry. Please try again.');
                }
            })
            .catch((err) => {
                console.error('Error updating cash received entry:', err);
                alert('Network error. Please try again later.');
            });
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Cash Received</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Edit Cash Received Entry</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="staffId" className="form-label">Staff ID</label>
                                        <input
                                            type="number"
                                            id="staffId"
                                            className="form-control"
                                            value={staffId}
                                            onChange={(e) => setStaffId(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="customerId" className="form-label">Customer ID</label>
                                        <input
                                            type="number"
                                            id="customerId"
                                            className="form-control"
                                            value={customerId}
                                            onChange={(e) => setCustomerId(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label">Amount</label>
                                        <input
                                            type="number"
                                            id="amount"
                                            className="form-control"
                                            value={amount}
                                            onChange={(e) => setAmount(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            rows="3"
                                            required
                                        />
                                    </div>
                                    <button type="submit" className="btn btn-primary">Update</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditCashReceiveds;
